import { LeadFormService } from './services/lead-form.service';
import { CreditApplicationModule } from './modules/credit-application/credit-application.module';
import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { DtAnCreditapplicationLibComponent } from './dt-an-creditapplication-lib.component';
import {
  provideClientHydration,
  BrowserModule
} from '@angular/platform-browser';
import { IConfig } from './interfaces/config.interface';
import { GlobalErrorHandler } from './utils/GlobalErrorHandler.class';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HTTPInterceptor } from './utils/HTTPInterceptor.class';
import { APP_BASE_HREF } from '@angular/common';
import { AppRoutingModule } from './dt-an-creditapplication-lib-routing.module';
import 'bingmaps';
import { DynamicYieldService } from './services/dynamicYield.service';
import { DtAnPricedetailsLibModule } from '@autonation/dt-an-pricedetails-lib';
@NgModule({
  declarations: [DtAnCreditapplicationLibComponent],
  imports: [
    BrowserModule,
    CreditApplicationModule,
    AppRoutingModule,
    DtAnPricedetailsLibModule
  ],
  exports: [DtAnCreditapplicationLibComponent],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    DynamicYieldService,LeadFormService,
    { provide: HTTP_INTERCEPTORS, useClass: HTTPInterceptor, multi: true },
    {
      provide: APP_BASE_HREF,
      useValue: '/'
    },
    provideClientHydration()
  ]
})
export class DtAnCreditapplicationLibModule {
  public static forRoot(config: IConfig): ModuleWithProviders<DtAnCreditapplicationLibModule> {
    return {
      ngModule: DtAnCreditapplicationLibModule,
      providers: [{ provide: 'config', useValue: config }]
    };
  }
}
